export enum ErrorMessage {
    requestErrorUnspecified = 'requestErrorUnspecified',
    conflict = 'conflict',
    couldNotSaveResult = 'couldNotSaveResult',
    couldNotProcessAssignment = 'couldNotProcessAssignment',
    selectedFileTooBig = 'selectedFileTooBig',
    selectedFilesTooBig = 'selectedFilesTooBig',
    selectedFileFormatUnacceptable = 'selectedFileFormatUnacceptable',
    selectedFilesFormatUnacceptable = 'selectedFilesFormatUnacceptable',
    selectedFilesMultipleProblems = 'selectedFilesMultipleProblems',
    selectedHotelHasNoAssessment = 'selectedHotelHasNoAssessment',
    attachmentLimitReached = 'attachmentLimitReached',
    fileUploadError = 'fileUploadError',
    fileFetchError = 'fileFetchError',
}
